<script>
    import Logo from './Logo.svelte';


let timeout = false
setTimeout(() => {
    timeout = true
  //console.log("Delayed for 2 second.");
}, "2000")

</script>

<div class="loading-wrapper" 
    class:displaynone={timeout}
>
    <div class="loading">
        <Logo /> 
    </div>
</div>